import { FormGroup } from '@angular/forms';

export function splitCsv(value?: string | null): string[] {
  return (value || '')
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
}

export function joinCsv(values: string[], optionOrder?: string[]): string {
  const unique = Array.from(new Set(values.filter(Boolean)));
  if (optionOrder?.length) {
    unique.sort((a, b) => optionOrder.indexOf(a) - optionOrder.indexOf(b));
  }
  return unique.join(', ');
}

export function coerceNumber(value: unknown): number | null {
  if (value === '' || value === null || value === undefined) return null;
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : null;
}

export function cleanFormValue<T extends Record<string, unknown>>(value: T): T {
  return Object.entries(value).reduce((result, [key, fieldValue]) => {
    (result as Record<string, unknown>)[key] = fieldValue === '' ? null : fieldValue;
    return result;
  }, {} as T);
}

export function markFormDirtyOnChange(form: FormGroup, callback: () => void): void {
  form.valueChanges.subscribe(() => callback());
}
